import { render } from "./Return.vue?vue&type=template&id=ce143522"
import script from "./Return.vue?vue&type=script&lang=js"
export * from "./Return.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Microsoft VS Code Project\\mft_stock_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__